---
title: Function Overloading in Swift
date: 2019-03-03T18:32:28-07:00
draft: true
---


"function overloading" just means you wrote multiple different functions, but with the same name

"But Joe, that’s confusing"

yes, yes it is

the compiler thinks so to

and in a lot of languages, it does one of two things:
1. throws an error that looks like "func foo already defined"
2. takes the last time (in code, not in time) you defined a function with that name, and just uses it

but some languages let you do different stuff

and swift is one of them

but the compiler is dumb, it does exactly what people tell it to do. For it to work in Swift (and other languages), we have to give it clues to know what to do

the way swift can do it, is by checking the type on what you pass as an argument

so you can have two `add` functions like so
```
func add(first:String, second:String) {
    print("\(first)\(second)!")
}

func add(first:Int, second:Int) {
    print(first + second)
}

// add(3,4) would return 7
// add("hi ", "sam") would return "hi sam"
```

and while they have the same name, they are different. One concatenates two strings together, the other adds two numbers

so the compiler sets up your program and tells itself "hey, whenever I see a function called `add`, I can’t just run a function. I need to first see what kind of input it takes, then I’ll know which of the functions to run"

this can still be confusing when you are reading code

One of the things I do to keep it clear in my head, is instead of saying ‘`add` function’ in my head when reading the code, I say/think ‘`add string` function’ or ‘`add int` function’
